var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['row-filter', _vm.classObject]},_vm._l((_vm.options),function(option){return _c('button',{key:option.id,staticClass:"row-filter__item",class:{
            'disabled': _vm.isDisable(option),
            'selected': _vm.isEnable(option),
        },on:{"click":function($event){return _vm.clickHandler(option)}}},[_c('span',{domProps:{"innerHTML":_vm._s(option.text)}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }